import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'
import imgPage from 'assets/images/eventWater/iconPage.png'
import imgTitle from 'assets/images/eventWater/textTitleWin.png'
import imgMoney from 'assets/images/eventWater/imgMoney.png'
import imgIpad from 'assets/images/eventWater/imgIpad.png'
import imgMipad from 'assets/images/eventWater/imgMiPad.png'
import { getCheckEventWaterQuery, getRankEventWaterQuery } from 'dataLayer/game'
import { useNavigate } from 'react-router-dom'
import { PATHS } from 'config/routes'
import { Col, Row } from 'react-bootstrap'
import { getUserQuery } from 'dataLayer/user'
const ResultEventWater = () => {
	const navigate = useNavigate()
	const { data, refetch: refetchRank } = useQuery(getRankEventWaterQuery())
	const { data: user, isLoading: isLoadingUser } = useQuery(getUserQuery())

	const {
		data: eventWater,
		isLoading: isLoadingEvent,
		refetch: refetchEvent,
	} = useQuery(getCheckEventWaterQuery())
	useEffect(() => {
		refetchEvent()
		refetchRank()
	}, [user])

	useEffect(() => {
		if (eventWater && !isLoadingEvent) {
			if (!eventWater.is_show || !eventWater.is_finished) {
				navigate(PATHS.HOME_PAGE)
			}
		}
	}, [eventWater, isLoadingEvent])

	const { t } = useTranslation()
	return (
		<div className="container-water">
			<div className="container-water-wrapper">
				<Row justify="center" style={{ margin: 0 }}>
					<Col xs={24} style={{ padding: 0 }}>
						<div className={`container-water-content detail`}>
							<div className="box-tab-content">
								<div className={`box-tab-content-detail `}>
									<div className="wapper-detail">
										<img src={imgPage} alt="icon page" className="img-win" />
										<img
											src={imgTitle}
											className="img-title"
											alt="title-page"
										/>
										<div className="wapper-detail-win">
											<div className="wapper-detail-win-item">
												<div className="item-rank">1st prize</div>
												<img src={imgMoney} alt="icon gift" />
												<div className="item-info">
													<span>{data?.ranks?.data[0]?.full_name}</span>
													<span>{data?.ranks?.data[0]?.msisdn}</span>
												</div>
											</div>
											<div className="wapper-detail-win-item">
												<div className="item-rank">2nd prize</div>
												<img src={imgIpad} alt="icon gift" />
												<div className="item-info">
													<span>{data?.ranks?.data[1]?.full_name}</span>
													<span>{data?.ranks?.data[1]?.msisdn}</span>
												</div>
											</div>
											<div className="wapper-detail-win-item">
												<div className="item-rank">3rd prize</div>
												<img src={imgMipad} alt="icon gift" />
												<div className="item-info">
													<span>{data?.ranks?.data[2]?.full_name}</span>
													<span>{data?.ranks?.data[2]?.msisdn}</span>
												</div>
											</div>
											<div className="wapper-detail-win-foot">
												<p className="wapper-detail-win-foot-text">
													{t('event.water.result.page')}
												</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</Col>
				</Row>
			</div>
		</div>
	)
}

export default ResultEventWater
